'use client';

import { SessionProvider as NextAuthSessionProvider } from 'next-auth/react';

export default function SessionProvider({ children }: { children: React.ReactNode }) {
  // Always wrap children in NextAuthSessionProvider
  return (
    <NextAuthSessionProvider>
      {children}
    </NextAuthSessionProvider>
  );
}